import React from 'react';

/** Abstract “energy / motion” visual — no photo */
export default function HeroVisual() {
  return (
    <div className="relative aspect-square w-full max-w-md mx-auto lg:max-w-none lg:aspect-[5/4]">
      <svg
        className="h-full w-full overflow-visible"
        viewBox="0 0 400 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <defs>
          <linearGradient id="dfg1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#e63946" stopOpacity="0.25" />
            <stop offset="50%" stopColor="#c1121f" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#1e293b" stopOpacity="0.08" />
          </linearGradient>
          <linearGradient id="dfg2" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#e63946" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#e63946" stopOpacity="0" />
          </linearGradient>
          <filter id="blur" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="24" />
          </filter>
        </defs>
        <circle cx="200" cy="200" r="160" fill="url(#dfg1)" />
        <ellipse
          cx="280"
          cy="120"
          rx="90"
          ry="70"
          fill="url(#dfg2)"
          filter="url(#blur)"
        />
        <ellipse
          cx="100"
          cy="280"
          rx="70"
          ry="90"
          fill="#e63946"
          fillOpacity="0.12"
          filter="url(#blur)"
        />
        <path
          d="M120 140 Q200 80 280 140 T320 260 Q240 320 160 280 T120 140"
          stroke="#e63946"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
          opacity="0.6"
        />
        <circle cx="200" cy="200" r="48" stroke="#e63946" strokeWidth="2" fill="white" fillOpacity="0.9" />
        <path
          d="M188 200 L198 210 L218 186"
          stroke="#e63946"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <rect x="60" y="320" width="280" height="4" rx="2" fill="#e2e8f0" />
        <rect x="60" y="320" width="180" height="4" rx="2" fill="#e63946" opacity="0.85" />
      </svg>
    </div>
  );
}
